import TemplateComponent from "shared/components/template/TemplateComponent";
import { type ProfileView } from "shared/mappers/database/profile/profile";
import { type SubmissionInstanceView } from "shared/mappers/database/submission/instance/submission-instance";
import { type WorkflowInstanceView } from "shared/mappers/database/workflow/workflow-instance";
import { useHubReviewsVotingPageContext } from "hub/src/context/reviews/HubReviewsVotingPageContext";

export type SubmissionPreviewProps = {
  submissionInstance?: SubmissionInstanceView;
  workflowInstance?: WorkflowInstanceView;
  disclosureInstance?: SubmissionInstanceView;
  submitterProfile: ProfileView;
  role?: string;
};

export const HubReviewsSubmissionPreview = ({
  submissionInstance,
  workflowInstance,
  submitterProfile,
  disclosureInstance,
}: SubmissionPreviewProps) => {
  const { reviewSession } = useHubReviewsVotingPageContext();

  return (
    <TemplateComponent
      className="pb-2"
      template={reviewSession.submissionTemplate ?? "No Template Found"}
      data={{
        workflowInstance,
        submissionInstance,
        disclosureInstance,
        submitterProfile,
      }}
    />
  );
};
